module.exports = __webpack_public_path__ + "static/img/xiantiaoronghe.09e5f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiantiaoronghe.png
// module id = mTV7
// module chunks = 3